import Swal from 'sweetalert2';

export function toast(tipo, texto) {
    if (texto) {
        Swal.fire({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            target: 'body',
            topLayer: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
            icon: tipo || 'info',
            html: texto
        });
    }
}

export function alert(tipo, titulo, texto) {
    if (titulo || texto) {
        Swal.fire({
            title: titulo || "",
            html: texto || "",
            icon: tipo || "info",
            target: 'body',
            showCancelButton: false,
            confirmButtonText: "Ok",
            customClass: {
                confirmButton: "btn btn-primary",
            },
            buttonsStyling: false
        });
    }
}

export function confirm(titulo, texto, acaoConfirmar, acaoCancelar) {
    if (titulo || texto) {
        Swal.fire({
            title: titulo || '',
            html: texto || '',
            icon: "question",
            target: 'body',
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1"
            },
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                if (typeof acaoConfirmar === 'function') {
                    acaoConfirmar();
                }
            } else {
                if (typeof acaoCancelar === 'function') {
                    acaoCancelar();
                }
            }
        });
    }
}